<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path
          d="M827.8 475.8c-19.1-43-46.5-81-81.3-112.9l-28.9-26.5c-.7-.6-1.5-.8-2-.8-1 0-2.3.5-2.8 1.9l-12.9 37.1c-8.3 23.9-23.4 48.2-44.9 72.2l-.1.1c-1.9 2.1-4.5 3.3-7.3 3.6h-1c-2.6 0-5.2-1-7.2-2.8-2.5-2.2-3.9-5.5-3.7-8.9 3.6-59-14.2-125.7-52.8-198.3-31.9-60.1-76.3-107.1-131.9-140l-41-24.1c-.4-.3-.9-.4-1.4-.4-.8 0-1.6.4-2.2 1-.4.4-.8 1.1-.8 2.1l2.2 47.8c1.5 33.4-2.4 62.8-11.6 87.5-11.1 29.9-27.2 57.6-47.6 82.5-14.5 17.5-30.7 33.2-48.1 46.7-41.2 31.6-75.2 72.8-98.3 119.1-23.2 46.6-35.5 98.9-35.5 151.3 0 46.3 9.1 91.1 27.1 133.3 17.5 40.8 42.4 77.4 74 108.7 31.9 31.5 68.8 56.2 109.7 73.3C420.3 947 465.4 956 512 956c46.5 0 91.7-9 134.2-26.8C687.5 912 724.4 887.4 756 856c31.7-31.3 56.6-67.9 74-108.7 18-42.2 27.2-87 27.2-133.3-.1-48-9.9-94.5-29.4-138.2zM715.5 814.9c-54.3 53.8-126.6 83.4-203.5 83.4s-149.2-29.6-203.5-83.4c-54.2-53.8-84.1-125.2-84.1-201 0-44 9.9-86.3 29.5-125.6 19-38.4 47.3-72.7 81.9-99.2 21.1-16.1 40.4-34.8 57.5-55.7 24.5-29.9 43.7-63.3 57.1-99 5.3-14.4 9.3-29.6 11.8-45.3l1.5-9.3 7 6.4c24.2 22.3 44.5 48.9 61.9 81.3 33.7 63.1 49.2 119.5 46.2 167.5-1.3 21 7 41.3 22.6 55.4 12.6 11.3 28.8 17.5 45.6 17.5 1.3 0 2.6 0 3.9-.1 18.2-.9 35-8.9 47.2-22.6 13.1-14.7 24.4-29.7 33.7-44.7l3.8-6.2 4.5 5.7c14.2 18.1 26.1 38 35.5 59.2 16.1 36.3 24.3 74.9 24.3 114.6-.3 76-30.2 147.4-84.4 201.1z"
        />
        <path d="M587 683.8c10.5 0 19-8.5 19-19s-8.5-19-19-19h-56V639l66.7-66.7c7.4-7.4 7.4-19.4 0-26.9-7.4-7.4-19.4-7.4-26.9 0l-58 58-59.8-59.8c-7.4-7.4-19.5-7.4-26.9 0-7.4 7.4-7.4 19.4 0 26.9l66.7 66.7v8.6h-56c-10.5 0-19 8.5-19 19s8.5 19 19 19h56v46.4h-56c-10.5 0-19 8.5-19 19s8.5 19 19 19h56v54.9c0 10.5 8.5 19 19 19s19-8.5 19-19v-54.9h56c10.5 0 19-8.5 19-19s-8.5-19-19-19h-56v-46.4H587z" />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
